<template>
	<v-dialog :fullscreen="isMobile" attach v-model="open" max-width="700px" scrollable>
		<v-card raised v-if="open">
			<v-card-title class="terms-modal__title pb-0 pl-0 pr-0 pt-0" style="width: 100%;">
				<div class="hidden-sm-and-up ma-3" style="display: flex; flex-direction: column; justify-content: space-between; height: 130px;">
					<a class="terms-modal__top-mobile-links" v-for="n in pages" :key="n.id+'2'" @click="changePage(n.id)" :style="linkStyle(n)">{{n.name}}</a>
				</div>
				<v-spacer></v-spacer>
				<button type="button" class="btn-flat-icon--dark mr-2 mt-2" @click="open=false"><v-icon large style="color: #AAA">close</v-icon></button>
				<v-tabs
					v-model="termsPage"
					show-arrows
					light
					color="transparent"
					slot="extension"
					value="id"
					style="max-width: 100%!important;"
					class="hidden-xs-only"
				>
					<v-tabs-slider
						color="yellow"
					></v-tabs-slider>
					<v-tab
						class="black--text"
						v-for="n in pages"
						:key="n['id']"
						ripple
					>
						{{ n['name'] }}
					</v-tab>
				</v-tabs>
			</v-card-title>
			<v-card-text :style="getStyle" class="pa-3">
				<v-tabs-items
					v-model="termsPage"
				>
					<v-tab-item
						v-for="n in pages"
						:key="n['id']"
					>
						<component :changepage="changePage" :is="n['component']"></component>
					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import TermsAndConditions from '~/components/modals/TermsAndConditions.vue'
import PrivacyPolicy from '~/components/modals/PrivacyPolicy.vue'
import ServiceFees from '~/components/modals/ServiceFees.vue'
import PaymentPolicy from '~/components/modals/PaymentPolicy.vue'
import NondiscriminationPolicy from '~/components/modals/NondiscriminationPolicy.vue'
import ContentPolicy from '~/components/modals/ContentPolicy.vue'
import CopyrightPolicy from '~/components/modals/CopyrightPolicy.vue'

import { mapGetters, mapActions } from 'vuex'
import { deepCopy } from '~/store/util/util'
export default {
	name: 'terms_modal',
	data() {
		return {
			pages: [
				{
					id: 'nondiscriminationpolicy',
					name: 'Nondiscrimination',
					component: NondiscriminationPolicy
				},
				{
					id: 'termsandconditions',
					name: 'Terms of Service',
					component: TermsAndConditions
				},
				{
					id: 'privacypolicy',
					name: 'Privacy',
					component: PrivacyPolicy
				},
				// {
				// 	id: 'servicefees',
				// 	name: 'Service Fees',
				// 	component: ServiceFees
				// },
				{
					id: 'paymentpolicy',
					name: 'Payments',
					component: PaymentPolicy
				},
				{
					id: 'contentpolicy',
					name: 'Content & Copyright',
					component: ContentPolicy
				}
				// {
				// 	id: 'copyrightpolicy',
				// 	name: 'Copyright Policy',
				// 	component: CopyrightPolicy
				// },
			]
		}
	},
	created() {
		this.$on('test', msg => {
			console.log(msg)
		})
	},
	methods: {
		...mapActions(['setModalOpen', 'setTermsPage']),
		changePage(page) {
			// console.log('')
			this.termsPage = String(
				this.pages.indexOf(this.pages.find(p => p.id === page))
			)
		},
		linkStyle(n) {
			if (n.id === this.pages[this.getTermsPage].id) {
				return {
					color: '#AAA!important'
				}
			}
		}
	},
	computed: {
		...mapGetters(['getModalProp', 'getTermsPage']),
		getStyle() {
			let style = {}
			if (!this.isMobile) {
				style = {
					'max-height': '70vh'
				}
				return style
			}
		},
		termsPage: {
			get() {
				return this.getTermsPage
			},
			set(val) {
				this.setTermsPage(val)
			}
		},
		open: {
			get() {
				let index = this.pages.indexOf(
					this.pages.find(p => String(p.id) === String(this.getTermsPage))
				)
				if (index !== -1) {
					this.termsPage = String(index)
				}
				return this.getModalProp('termsModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'termsModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.dialog {
	overflow-y: visible !important;
}
</style>
